<template>
	<div
		class="module module-social-share-container social-share-tools"
		:class="{vertical: this.$props.vertical}"
		data-e2e="social-sharebar"
	>
	
		<div
			class="plugin plugin-socialshare"
			:data-metrics-module="metrics.module"
		>
		<div class="share-container" @click="openTooltip()">
			<div class="webmd-icon-share"></div>
			<div class="share-text">Share</div>
		</div>
		<div class="share-icons">
			<div class="share-icons-tooltip">
				<template v-for="(item, index) in items">
					<a
						:class="[item.className, {right: item.position === 'right'}]"
						v-metric="{
							module: metrics.module,
							link: item.metric
						}"
						:data-metrics-type="metrics.type"
						:data-sharetype="item.type"
						:href="item.href"
						:title="item.title"
						rel="noopener"
						:key="index"
						role="link"
						tabindex="0"
						@click="setClickHandler(item.type)"
						v-if="item.type === 'email'"
					>
						<div
							class="social-icon-container"
						>
							<i :class="item.icon"></i>
						</div>
						<span
							class="visually-hidden"
						>
							{{ item.msg }}
						</span>
					</a>

					<a
						:class="[item.className, {right: item.position === 'right'}]"
						v-metric="{
							module: metrics.module,
							link: item.metric
						}"
						:data-metrics-type="metrics.type"
						:data-sharetype="item.type"
						:href="item.href"
						:title="item.title"
						rel="noopener"
						:key="chronicleId+index"
						role="link"
						tabindex="0"
						@click.prevent="setClickHandler(item.type)"
						v-else
					>
						<div
							class="social-icon-container"
						>
							<i :class="item.icon"></i>
						</div>
						<span
							class="visually-hidden"
						>
							{{ item.msg }}
						</span>
					</a>
				</template>
				
			</div>
		</div>
		<span v-if="showTooltipText" class="copy-link-tooltip">copied</span>
		</div>
	</div>
</template>

<script>
import { ajax } from 'jquery';
import { ua } from 'webmd-useragent/index.es6';
import {getEnv, getLifecycle} from 'webmd-url';	
/* eslint max-len: ["error", { "code": 1000, "tabWidth": 4 }] */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ['a'] }] */
export default {
	name: 'GlobalSharebar',
	props: {
		shareOrder: {
			type: Array,
			default() {
				return ['facebook', 'twitter','email', 'copy'];
			},
		},
		vertical: {
			type: Boolean,
			default: false,
		},
		facebook: {
			type: Object,
			default() {
				return {};
			},
		},
		pinterest: {
			type: Object,
			default() {
				return {};
			},
		},
		twitter: {
			type: Object,
			default() {
				return {};
			},
		},
		copy: {
			type: Object,
			default() {
				return {};
			},
		},
		googleplus: {
			type: Object,
			default() {
				return {};
			},
		},
		email: {
			type: Object,
			default() {
				return {};
			},
		},
		save: {
			type: Object,
			default() {
				return {};
			},
		},
		print: {
			type: Object,
			default() {
				return {};
			},
		},
		shareLink: {
			type: String,
			default: null,
		},
		shareTitle: {
			type: String,
			default: null,
		},
		shareWithTwoUrls: {
			type: Boolean,
			default: false,
		},
		customFbUrl: {
			type: String,
			required: false,
		},
		shareImage: {
			type: String,
			required: false,
		},
	},

	data() {
		return {
			chronicleId: '091e9c5e8136fcb5',
			metrics: {
				module: 'fm-shr',
				type: 'ad-hoc',
			},
			items: [],
			settings: {},
			shortenedUrls: {},
			showTooltipText: false,
			deviceInfo: false
		};
	},

	computed: {
		getItems() {
			const self = this;
			const items = [];
			let { shareOrder } = this.$props;

			if (typeof shareOrder === 'undefined' || shareOrder.length <= 0) {
				shareOrder = ['facebook', 'twitter', 'email', 'copy'];
			}

			shareOrder.forEach((v) => {
				let icon;
				if (v === 'print') {
					icon = 'printer';
				} else if (v === 'save') {
					icon = 'bookmark';
				} else {
					icon = v;
				}
				const obj = {
					className: `plugin-socialshare-link plugin-socialshare-${icon}`,
					title: self.getShareTitle(v),
					msg: self.getShareText(v),
					metric: self.getMetricsText(v),
					position: '',
					type: v,
					icon: `webmd-icon-${icon}`,
				};

				if (typeof self.$props[v] !== 'undefined') {
					// eslint-disable-next-line
					if(typeof self.$props[v].href !== 'undefined') {
						obj.href = self.$props[v].href;
					}

					if (typeof self.$props[v].position !== 'undefined') {
						obj.position = self.$props[v].position.toLowerCase();
					}

					self.settings[v] = self.$props[v];
				} else {
					self.settings[v] = {};
				}

				items.push(obj);
			});
			return items;
		},
	},

	created() {
		this.items = this.getItems;
	},

	methods: {
		getShareTitle(type = '') {
			let s = '';

			switch (type) {
				case 'facebook':
					s = 'Share on Facebook';
					break;
				case 'pinterest':
					s = 'Share on Pinterest';
					break;
				case 'twitter':
					s = 'Share on X';
					break;
				case 'googleplus':
					s = 'Share on Googleplus';
					break;
				case 'email':
					s = 'Share via Email';
					break;
				case 'save':
					s = 'Save this page';
					break;
				case 'print':
					s = 'Print this page';
					break;
				case 'copy':
					s = 'Copy';
					break;
				default:
					s = '';
			}

			return s;
		},
		getShareText(type = '') {
			let s = '';

			switch (type) {
				case 'facebook':
					s = 'Share on Facebook';
					break;
				case 'pinterest':
					s = 'Share on Pinterest';
					break;
				case 'twitter':
					s = 'Share on X';
					break;
				case 'googleplus':
					s = 'Share on Googleplus';
					break;
				case 'email':
					s = 'Email';
					break;
				case 'save':
					s = 'Save';
					break;
				case 'print':
					s = 'Print';
					break;
				case 'copy':
					s = 'Copy';
					break;
				default:
					s = '';
			}

			return s;
		},
		getMetricsText(type = '') {
			let s = '';

			switch (type) {
				case 'facebook':
					s = 'fb';
					break;
				case 'pinterest':
					s = 'pin';
					break;
				case 'twitter':
					s = 'tw';
					break;
				case 'googleplus':
					s = 'goog';
					break;
				case 'email':
					s = 'email';
					break;
				case 'save':
					s = 'save';
					break;
				case 'print':
					s = 'print';
					break;
				case 'copy':
					s = 'copy';
					break;
				default:
					s = '';
			}

			return s;
		},
		setClickHandler(type = '') {
			const windowOpts = 'height=400, width=580, scrollbars = 1, toolbar = 0, resizable = 1, status = 0, left = 25, top = 25';
			switch (type) {
				case 'facebook':
					window.open(this.getFacebookShareLink(this.settings[type].settings || {}), '', windowOpts);
					break;
				case 'pinterest':
					window.open(this.getPinterestShareLink(this.settings[type].settings || {}), '', windowOpts);
					break;
				case 'twitter':
					this.getTwitterShareLink(this.settings[type].settings || {}).then((shortLink) => {
						window.open(shortLink, '', windowOpts);
					});
					break;
				case 'googleplus':
					window.open(this.getGoogleplusShareLink(this.settings[type].settings || {}), '', windowOpts);
					break;
				case 'email':
					break;
				case 'save':
					break;
				case 'print':
					window.print();
					break;
				case 'copy':
					this.copyLink();
					break;
				default:
			}
		},
		getFacebookShareLink(settings) {
			if (this.customFbUrl) {
				return this.customFbUrl;
			}

			const baseUrl = 'https://www.facebook.com/dialog/feed?app_id=385978254785998&display=popup';
			const picture = `&picture=${encodeURIComponent(settings.shareImg || '')}`;
			const redirect = `&redirect_uri=${encodeURIComponent('https://www.webmd.com/facebook-app-close')}`;
			const name = `&name=${encodeURIComponent(settings.shareTitle || '')}`;
			const link = `&link=${encodeURIComponent(settings.shareLink || '')}`;
			const caption = `&caption=${encodeURIComponent(settings.shareTitle || '')}`;
			const description = `&description=${encodeURIComponent(settings.shareDesc || '')}`;
			this.closeTooltip();
			return baseUrl + picture + redirect + name + link + caption + description;
		},
		getPinterestShareLink(settings) {
			let description = '';
			let media = '';
			if (this.shareWithTwoUrls === true) {
				description = `&description=${encodeURIComponent(settings.shareTitle || '')}`;
				media = `&media=${encodeURIComponent(this.shareImage || '')}`;
			} else {
				description = `&description=${encodeURIComponent(settings.shareTitle || '')} | WebMD`;
				media = `&media=${encodeURIComponent(settings.shareImg || '')}`;
			}
			const baseUrl = 'https://pinterest.com/pin/create/button/?';
			const url = `url=${encodeURIComponent(settings.shareLink || '')}`;
			this.closeTooltip();
			return baseUrl + url + media + description;
		},
		async getTwitterShareLink(settings) {	
			const shortenApiUrl = 'https://api-ssl.bitly.com/v4/shorten';
			const token = '34543b055a4fc76fa6e5969de2abc6f323145392';
			const shareLink = settings && settings.shareLink;
			let isProd = (!getEnv(settings.shareLink) && !getLifecycle(settings.shareLink)) ? true : false;
			let twitterShareLink;
			//If url is already available, form the twitterShareLink with it
			if (this.shortenedUrls[shareLink]) {
				this.shortenedUrls[shareLink] = this.shortenedUrls[shareLink];
			} 
			//If the url is friendly prod live, call the bitly shorten url api
			else if ((typeof this.shortenedUrls[shareLink] === 'undefined' || this.shortenedUrls[shareLink] === '') && isProd && !window.location.href.includes("/assetid-")) {
				const response = await fetch(shortenApiUrl, {
					method: 'POST',
					domain: 'wb.md',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${token}`,
					},
					body: JSON.stringify({ long_url: `${shareLink}` }),
				});
				const data = await response.json();
				const smallUrl = data;
				if (typeof smallUrl.link === 'string' && /^https?:\/\/[^.]+\.[^/]+\/.+/gi.test(smallUrl.link)) {
					this.shortenedUrls[shareLink] = smallUrl.link;
				} else {
					this.shortenedUrls[shareLink] = shareLink;
				}
			}
			// For all other urls, use friendly url without shortening
			 else {
				this.shortenedUrls[shareLink] = shareLink;
			}

			if (this.shareWithTwoUrls === true) {
				twitterShareLink = `https://x.com/intent/tweet?text=${encodeURIComponent(this.shareMsg(settings) || '')} ${encodeURIComponent(this.shortenedUrls[shareLink])} from @WebMD ${encodeURIComponent(shortenedUrl)}`;
			} else {
				twitterShareLink = `https://x.com/intent/tweet?text=${encodeURIComponent(settings.shareTitle || '')} ${encodeURIComponent(this.shortenedUrls[shareLink])} from @WebMD;`;
			}
			this.closeTooltip();
			return new Promise((resolve) => {
				setTimeout(() => {
					resolve(twitterShareLink);
				}, 0);
			});
		},
		shareMsg(settings) {
			let title = '';
			const urlLength = settings.shareLink.length * 2 + 15;
			let titleLength = 0;

			if (settings.shareTitle) {
				titleLength = settings.shareTitle.length;
			}

			const twitterLength = 280 - urlLength;
			let totalTitleLenth = titleLength - twitterLength;

			if (totalTitleLenth > 0) {
				totalTitleLenth += 3;
				const newTitleLength = titleLength - totalTitleLenth;
				const trimmedTitle = settings.shareTitle.substring(0, newTitleLength);

				title = `${trimmedTitle}...`;
			} else {
				title = `${settings.shareTitle}`;
			}
			this.closeTooltip();
			return title;
		},
		getGoogleplusShareLink(settings) {
			return `https://plus.google.com/share?url=${encodeURIComponent(settings.shareLink || '')}`;
		},
		copyLink () {
			let artNum = 0;
			let url = window.location.href;
			const artId = this.getArticleId();
			if(window && window.infiniteList && artId) {
				artNum = Object.keys(window.infiniteList).indexOf(artId);
				url = window.infiniteList[artId].omniture.s_pagename;
			}
			window.navigator.clipboard.writeText(url);
			this.showTooltipText = true;
			window.setTimeout(() => {
				this.showTooltipText = false;
				if(this.deviceInfo != 'desktop') {
					window.setTimeout(() => {
						document.getElementsByClassName('share-icons')[artNum].classList.add('hide');
					}, 2000);
				}
			}, 1000);
		},
		openTooltip () {
			if(this.deviceInfo != 'desktop') {
				let artId = this.getArticleId();
				let artNum = 0;
				let childEle = this.$el.children[0];
				if(window && window.infiniteList && artId) {
					artNum = Object.keys(window.infiniteList).indexOf(artId);
				}
				this.$vwmdPageLink({ moduleName: 'fm-shr_share'});
				const ele = childEle && childEle.children[1] && childEle.children[1].classList;
				if (ele && ele.value && ele.value.includes('share-icons')) {
					if (ele && ele.value && ele.value.includes('hide')) {
						ele.remove('hide');
					}
					ele.add('show');
				}
			}
		},
		getArticleId () {
			let artId;
			if(this.$el.closest('article')) {
				artId = this.$el.closest('article').dataset.artid;
			} else {
				artId = 0;
			}
			return artId;
		},
		closeTooltip() {
			if(this.deviceInfo != 'desktop') {
				[...document.getElementsByClassName('share-icons')].forEach((el) => {
					el.classList.remove('show');
					el.classList.add('hide');
				});
			}
		}
	},

	mounted() {
		const self = this;
		const title = self.shareTitle || window.document.title || '';
		const shareLink = self.shareLink || window.location.href;
		this.deviceInfo = ua.type;
		Object.keys(this.settings).forEach((i) => {
			if (typeof self.settings[i].settings === 'undefined') {
				self.settings[i].settings = {};
			}

			if (typeof self.settings[i].settings.shareLink === 'undefined') {
				self.settings[i].settings.shareLink = shareLink;
			}

			if (typeof self.settings[i].shareTitle === 'undefined') {
				self.settings[i].settings.shareTitle = title;
			}
		});

		[...self.$el.querySelectorAll('.plugin-socialshare-email')].forEach((a) => {
			if (typeof a !== 'undefined' && (a.href === undefined || a.href === '')) {
				a.href = `mailto:?subject=${title}&body=I visited WebMD and thought that you would be interested in the information below. %0A${shareLink}%0A %20 %0A To view, click on the address above or copy and paste it into your Web browser.%0A %20 %0A LEARN MORE AT WEBMD - the nation%27s most trusted health and wellness resource.%0A https://www.webmd.com/ %0A Copyright 2023 WebMD, All rights reserved. %0A WebMD does not provide medical advice, diagnosis or treatment.`;
			}
		});
		document.addEventListener("click", (args) => { 
			const targetElement = document.getElementsByClassName('share-text')[0];
			const tooltipEle = document.getElementsByClassName('share-icons-tooltip')[0];
			if(args.target.className === 'webmd-icon-email' || (args.target.className != targetElement.className && args.target.offsetParent && args.target.offsetParent.className != tooltipEle.className)) {
				if (args.target.className != 'webmd-icon-share'){
					this.closeTooltip();
				}
			}
		});
	},
};
</script>

<style lang="scss">
$black: #000;
$tablet: 47.938em;
.pub-info-and-share-bar {
	@media screen and (max-width: 1023px) {
		padding-bottom: 20px;
	}
}
.module-social-share-container {
	margin-bottom: 0.4688rem;
	@media screen and (max-width: 47.938rem) {
		margin-bottom: 0.6875rem;
	}
	.share-icons {
		@media screen and (max-width: 1023px) {
			display: none;
			height: 40px;
			.share-icons-tooltip {
				background-color: #fff;
				text-align: center;
				border-radius: 3px;
				padding: 5px 0;
				box-shadow: 0px 1px 2px 2px #ddd;
				position: absolute;
				width: 190px;
				right: 2px;
				.copy-link-tooltip {
					left: 63%;
				}
			}
			.share-icons-tooltip:after {
				background: #fff;
				box-shadow: -5px -5px 3px -5px #999;
				bottom: 64%;
				content: "";
				height: 20px;
				left: 85%;
				position: absolute;
				width: 20px;
				transform: rotate(45deg);
			}
		}
		@media screen and (min-width: 1024px) {
			float: left;
		}
	}
	.copy-link-tooltip {
		background: #eee;
		font-size:14px;
		padding: 3px 5px;
		position: absolute;
		right: 0;
		top: 25px;
		@media screen and (max-width: 1023px) {
			right: 10px;
    		top: 60px;
		}
	}
	.show {
		display: block !important;
	}
	.hide {
		display: none !important;
	}
	.share-container {
		@media screen and (min-width: 1024px) {
			float: left;
		}
		@media screen and (max-width: 1023px) {
			display: flex;
			justify-content: right;
		}
		.share-text {
			color: #504d4d;
			font-family: "Source Sans Pro", Verdana, sans-serif;
			font-size: 14px;
			font-weight: 700;
			line-height: 14px;
			float: left;
			margin-top: 10px;
			margin-right: 10px;
			@media screen and (max-width: 1023px) {
				margin-top: 6px;
			}
		}
		.webmd-icon-share {
			@media screen and (min-width: 1024px) {
				display: none;
			}
			background-image: url("https://img.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/icons/icon-share-arrow.svg");
			background-repeat: no-repeat;
			background-position: center;
			height: 1.875rem;
			width: 1.875rem;
		}
	}

	.plugin-socialshare-link {
		color: $black;
		cursor: pointer;
		display: inline-block;
		margin: 0 1rem 0 0;
		
		&:link {
			text-decoration: none;
		}

		&::before {
			font-size: 2rem;
			font-family: icons;
		}

		&.right {
			float: right;
		}

		[class^=webmd-icon-],
		[class^=webmd-icon-]:before {
			font-size: 1.875rem;
			height: 1.875rem;
			width: 1.875rem;
		}
		.webmd-icon-facebook:before {
				background-image: url("https://img.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/icons/icon-facebook.svg");
		}
		.webmd-icon-twitter:before {
			background-image: url("https://img.webmd.com/vim/live/webmd/consumer_assets/site_images/icons/icon_x_grey.svg");	
		}
		.webmd-icon-pinterest:before {
			background-image: url("https://img.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/icons/icon-pinterest.svg");
		}
		.webmd-icon-copy {
			background-image: url("https://img.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/icons/icon-share-copy.svg");
			background-repeat: no-repeat;
    		background-position: left;
		}
		.webmd-icon-email:before {
			background-image: url("https://img.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/icons/icon-email.svg");
			content: "";
			display: block;
		}
		.webmd-icon-bookmark:before {
			font-size: 1.125rem;
			height: 1.125rem;
			margin-left: 0.5rem;
			width: 1.125rem;
		}
		.webmd-icon-printer:before {
			font-size: 1.2188rem;
			height: 1.125rem;
			margin-left: 0.3125rem;
			width: 1.125rem;
		}
		[class^=webmd-icon-]:hover,
		[class^=webmd-icon-]:focus {
			filter: invert(70%) sepia(2%) saturate(231%) hue-rotate(73deg) brightness(96%) contrast(88%);
			}
	}

	&.vertical {
		width: 2rem;

		.plugin-socialshare-link {
			margin: 0 0 0.875rem 0;
		}
	}

	.plugin-socialshare-printer {
		display:none;
	}

}

.visually-hidden {
	height: 1px;
	left: -10000px;
	margin: -1px;
	overflow: hidden;
	position: absolute !important;
	top: auto;
	width: 1px;
}
// overwrite sitefronts pages styles for sharebar
html.webmd-sf {
	.plugin-socialshare {
		@media screen and (max-width: 1023px) {
			align-items: center;
			display: flex;
		}
		a {
			background: transparent!important;
			margin: 0 0.75rem 0 0!important;
			&::before {
				display: none!important;
			}
			&:hover {
				background-color: transparent!important;
			}
		}
	}
	.share-icons-tooltip {
		@media screen and (max-width: 1023px) {
			top: 40px !important;
			a {
				line-height: normal!important;
			}
		}
	}
	.social-icon-container {
		display: block!important;
	} 
}

</style>
